import React from 'react';
import { tem45AnosOuMais, isMasculino } from '../../rules/documentRules';
import { formatCPFCNPJ } from '../../../../../utils/formatters';
import { InfoBox, InfoRow, InfoLabel, InfoValue, InfoMessage } from './styles';

// Nome/CPF vêm do formulário quando o pedido tem esses campos; senão (ex: pedidos
// de sociedade, que não pedem os dados do advogado), cai no usuário logado.
export const RequerenteInfoBox = ({ formData, nomeRequerente, documentoRequerente }) => {
  const nome = formData.nomeCompleto || formData.nome || nomeRequerente;
  const cpf = formData.cpf || (documentoRequerente && formatCPFCNPJ(String(documentoRequerente)));

  return (
    <InfoBox>
      <InfoRow>
        <InfoLabel>Requerente:</InfoLabel>
        <InfoValue>{nome || 'Não informado'}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>CPF:</InfoLabel>
        <InfoValue>{cpf || 'Não informado'}</InfoValue>
      </InfoRow>
    </InfoBox>
  );
};

export const LimitesInfoBox = () => (
  <InfoBox style={{ background: '#e0f2fe', border: 'none' }}>
    <InfoRow>
      <InfoLabel>📄 Limite total dos arquivos:</InfoLabel>
      <InfoValue>Máximo de 30MB somando todos os documentos</InfoValue>
    </InfoRow>
    <InfoRow>
      <InfoLabel>📑 Formato permitido:</InfoLabel>
      <InfoValue>Apenas PDF</InfoValue>
    </InfoRow>
  </InfoBox>
);

export const ReservistaInfoMessage = ({ formData }) => {
  // Só pra quem seria obrigado se fosse mais novo: homens (a regra do reservista)
  const shouldShow = isMasculino(formData.sexo) && tem45AnosOuMais(formData.dataNascimento);
  
  if (!shouldShow) return null;
  
  return (
    <InfoMessage>
      <strong>ℹ️ Informação importante:</strong>
      Conforme o Artigo 5º da Lei nº 4.375/1964 (Lei do Serviço Militar),
      pessoas com 45 anos ou mais estão desobrigadas de apresentar o
      Certificado de Reservista ou Dispensa.
    </InfoMessage>
  );
};